// extracted by mini-css-extract-plugin
module.exports = {"generic":"Reset_generic__3hz-n","mainheading":"Reset_mainheading__8a614","fieldWrapper":"Reset_fieldWrapper__M62Au","buttonWrapper":"Reset_buttonWrapper__1KabT"};